import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { DashboardType } from '@/types/dashboardType';
// Types
import type { SocialProfileType } from '@/types/socialProfileType';

import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';
//Components
import ItemWrapper from '@/components/pages/reports/components/Items/ItemWrapper';

type DashboardItemProps = {
    socialProfiles: SocialProfileType[];
    spGroups?: SpGroupType[];
    item: DashboardType;
    size: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
    spClassName?: string;
};

const DashboardItem = ({
    socialProfiles,
    spGroups,
    item,
    size = 'sm',
    className,
    spClassName
}: DashboardItemProps) => {
    const { t } = useTranslation('reports');

    return (
        <ItemWrapper
            spList={spGroups?.length > 0 ? [...spGroups, ...socialProfiles] : socialProfiles}
            mainContent={item?.name}
            subContent={
                (socialProfiles?.length > 0
                    ? t('create.social_profile', {
                          count: socialProfiles?.length
                      })
                    : '') +
                (spGroups?.length > 0
                    ? (socialProfiles?.length > 0 ? ', ' : '') +
                      t('create.group', {
                          count: spGroups?.length
                      })
                    : '')
            }
            size={size}
            className={className}
            spClassName={spClassName}
        />
    );
};

export default DashboardItem;
